export default {"src":"/_next/static/media/guidelines.682436d7.svg","height":45,"width":45,"blurWidth":0,"blurHeight":0};